/** @jsxImportSource theme-ui */
import { SIDEBAR_LINKS } from "components/dashboard/DashboardSidebar";
import { useRole } from "hooks/UseRole";
import { useRouter } from "next/router";
import { validatePermissions } from "utils/UserHelpers";
import NavLink from "./NavLink";

const DashboardLinks = () => {
  const currentRole = useRole();
  const router = useRouter();

  if (!currentRole) return null;
  return (
    <>
      {SIDEBAR_LINKS.map(({ text, icon, permission, link, type }) => {
        if (validatePermissions(currentRole, permission, type)) {
          return (
            <li key={text}>
              <NavLink href={link} text={text} />
            </li>
          );
        } else {
          return null;
        }
      })}
    </>
  );
};

export default DashboardLinks;
